import { type ReactElement } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthProvider';

/**
 * Schuetzt den /app-Bereich. Solange die Sitzung geprueft wird, zeigt es einen
 * Ladezustand; ohne Login leitet es auf /login um (mit Merker fuer Rueckkehr).
 */
export default function RequireAuth(): ReactElement {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-200 border-t-blue-600" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
